// Display-only feature switches. Routes, data, and backend capabilities remain available.
export default Object.freeze({
  news: false,
  flashDeals: false,
});
